import axios from 'axios'
import {MessageBox} from 'element-ui'
import store from '@/store'
import router from '../router/index'
import {getToken} from '@/utils/auth'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_API, // api 的 base_url
  timeout: 10000, // request timeout
  transformRequest: [
    function (data) {
      // 将数据转换为表单数据
      let ret = ''
      for (const it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }
  ]
})

// request interceptor
service.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    // Do something before request is sent
    if (store.getters.token) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers['token'] = getToken()
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    console.log('request interceptors')
    Promise.reject(error)
  }
)
// service.defaults.headers.common['Token'] = getToken()
// response interceptor
service.interceptors.response.use(
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data
    if (res.code > 0) {
      // Message({
      //   message: res.msg,
      //   type: 'error',
      //   duration: 5 * 1000
      // })
      console.log(res)
      if (res.code === 40001) {
        store.dispatch('FedLogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
        router.push('login')
      } else {
        MessageBox.alert(res.msg, '提示')
        return response
      }
      /*      else {
        MessageBox.confirm(
          res.msg,
          '确定登出',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
      }*/
      return Promise.reject('error')
    } else {
      return response
    }
  },
  error => {
    console.log('responseErr:\n' + error) // for debug
    console.log(1111111)
    /*    Message({
      message: error.response.data.msg,
      type: 'error',
      duration: 5 * 1000
    })*/
    if (error.toString().toLowerCase().indexOf('timeout') !== -1) {
      MessageBox.alert('连接超时，请等5秒后刷新再试', '提示：')
    } else if (error.response && (error.response.status === 401 || error.response.status === 422)) {
      // 请自行在引入 MessageBox
      MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出',
        {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        store.dispatch('FedLogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
      })
    } else if (error.toString().indexOf('404') !== -1) {
      MessageBox.alert('404 - 请求未找到，请刷新稍后再试。如果多次不能解决请联系管理员！', '提示：')
    } else if (error.toString().toLowerCase().indexOf('network error') !== -1) {
      MessageBox.confirm('网络异常，请稍后刷新再试！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log('发生错误，点击了确定')
      }).catch(() => {
        console.log('发生错误，点击了取消')
      })
    } else {
      MessageBox.confirm(error, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    }
    return Promise.reject(error)
  }
)

export default service
